import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=98ade256&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"
import style0 from "./Activation.vue?vue&type=style&index=0&id=98ade256&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ade256",
  null
  
)

export default component.exports